export const INCLUDED = 'included';
export const EXCLUDED = 'excluded';

export const EXCLUDED_GROUP_INDEX = 0;
export const INCLUDED_GROUP_INDEX = 1;
